import { KojiHTMLConverter } from './converter/KojiHTMLConverter';
import { KojiAstBuilder, } from './KojiAstBuilder';
import { KojiParser } from './KojiParser';
import { CommonTokenStream, CharStreams, } from 'antlr4ts';
import { KojiLexer } from './KojiLexer';
import { KojiXMLConverter } from './converter/KojiXMLConverter';
import { KojiDocxDocumentConverter } from './converter/KojiDocxDocumentConverter';
import inlineConversionRules from './converter/inline_rules';
import blockConversionRules from './converter/block_rules';
import { toBlob, toBase64String, toBuffer, } from './converter/KojiDocxCompiler';
import { KojiLaTeXConverter } from './converter/KojiLaTeXConverter';
class AccumlateErrorListener {
    constructor() {
        this.errors = [];
    }
    syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, exception) {
        //console.log(offendingSymbol);
        this.errors.push({
            line,
            charPositionInLine,
            msg,
            offendingSymbol,
        });
    }
}
export function tokenize(input) {
    const cs = CharStreams.fromString(input);
    const lexer = new KojiLexer(cs);
    const errorHandler = new AccumlateErrorListener();
    lexer.addErrorListener(errorHandler);
    const stream = new CommonTokenStream(lexer);
    stream.fill();
    return {
        tokens: stream.getTokens(),
        errors: errorHandler.errors,
    };
}
export function parse(input) {
    const cs = CharStreams.fromString(input);
    const lexer = new KojiLexer(cs);
    const ts = new CommonTokenStream(lexer);
    const parser = new KojiParser(ts);
    const errorHandler = new AccumlateErrorListener();
    lexer.addErrorListener(errorHandler);
    parser.addErrorListener(errorHandler);
    const tree = parser.koji();
    const visitor = new KojiAstBuilder();
    const ast = visitor.visit(tree);
    const errors = errorHandler.errors;
    return { ast, errors };
}
export function convertToHTML(ast, options) {
    const converter = new KojiHTMLConverter(options);
    return converter.convert(ast);
}
export function convertToXML(ast, options) {
    const converter = new KojiXMLConverter(options);
    return converter.convert(ast);
}
export function convertToTEI(ast) {
    const xml = convertToXML(ast);
    return `<?xml version="1.0" encoding="UTF-8"?>
<?xml-model href="http://www.tei-c.org/release/xml/tei/custom/schema/relaxng/tei_all.rng" type="application/xml"
	schematypens="http://purl.oclc.org/dsdl/schematron"?>
<TEI xmlns="http://www.tei-c.org/ns/1.0">
   <teiHeader>
      <fileDesc>
         <titleStmt>
            <title>Title</title>
         </titleStmt>
         <publicationStmt>
            <p>Publication Information</p>
         </publicationStmt>
         <sourceDesc>
            <p>Information about the source</p>
         </sourceDesc>
      </fileDesc>
   </teiHeader>
   ${xml}
</TEI>
	`;
}
export function convertToDocxDocumentXml(ast, options) {
    const converter = new KojiDocxDocumentConverter(options);
    return converter.convert(ast);
}
export function convertToLaTeX(ast, options) {
    const converter = new KojiLaTeXConverter(options);
    return converter.convert(ast);
}
export function convertToDocx(ast, type) {
    if (type === 'blob') {
        return toBlob(ast);
    }
    else if (type === 'base64') {
        return toBase64String(ast);
    }
    else if (type === 'buffer') {
        return toBuffer(ast);
    }
}
export const conversionRules = {};
inlineConversionRules.forEach((r) => (conversionRules[r.elemName] = r));
blockConversionRules.forEach((r) => (conversionRules[r.elemName] = r));
//# sourceMappingURL=data:application/json;base64,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